<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-12">
          <div
            class="orders-header col-12 d-flex align-items-center justify-content-between has-border">
            <div class="d-flex align-items-center gap-3">
              <h2 class="mb-0 fw-semibold me-3">Delivery Status</h2>

              <label class="d-flex align-items-center mb-0">
                <p-radioButton
                  id="Delivery exception"
                  class="me-2"
                  name="radio"
                  value="Delivery exception"
                  [(ngModel)]="deliveryStatus"
                  (click)="getDeliveryStatusOnChange($event)" />
                <span>Delivery Exception</span>
              </label>

              <label class="d-flex align-items-center mb-0">
                <p-radioButton
                  id="Delivered"
                  class="me-2"
                  name="radio"
                  value="Delivered"
                  [(ngModel)]="deliveryStatus"
                  (click)="getDeliveryStatusOnChange($event)" />
                <span>Delivered</span>
              </label>
            </div>

            <div>
              <p-button
                label="Export excel"
                variant="outlined"
                icon="pi pi-cloud-upload"
                severity="secondary"
                class="link"
                (click)="exportExcelForFilterData()"
                class="fullwdth secondary-btn" />
            </div>
            <!-- <div class="orders-panel d-flex align-items-center gap-3">
              <div class="lds-ring inline sm-loader" *ngIf="showSmallLoader">
                <jni-spinner></jni-spinner>
              </div>
              <div class="ms-3 nav-link p-0 d-flex align-items-center">
                <i class="icon-Export-excel me-2"></i>
                <a class="link" (click)="exportExcelForFilterData()"
                  >Export excel</a
                >
              </div>
            </div> -->
          </div>
        </span>
      </span>
      <div class="col-lg-12">
        <p-table
          #dt
          [value]="statusList"
          stripedRows
          styleClass="p-datatable-customers ordersListing search-more table-listing no-border"
          [rowHover]="true"
          [rows]="defaultTake"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          [scrollable]="true"
          scrollHeight="calc(100vh - 265px)"
          [size]="'small'"
          [resizableColumns]="true"
          responsiveLayout="scroll"
          selectionMode="single"
          [lazy]="true"
          (onLazyLoad)="getWorkflowDeliveryStatuses($event)"
          [totalRecords]="totalCount"
          sortMode="multiple">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th pSortableColumn="workflowId">
                Proposed Project
                <p-sortIcon field="workflowId"></p-sortIcon>
              </th>
              <th pSortableColumn="salesOrderIdD365">
                Sales Order
                <p-sortIcon field="salesOrderIdD365"></p-sortIcon>
              </th>
              <th pSortableColumn="trackingNumber">
                Tracking Number
                <p-sortIcon field="trackingNumber"></p-sortIcon>
              </th>
              <th>Line Number</th>
              <th pSortableColumn="nickName">
                Nickname
                <p-sortIcon field="nickName"></p-sortIcon>
              </th>
              <th>Shipping Method</th>
              <th
                *ngIf="deliveryStatus === 'Delivery exception'"
                pSortableColumn="deliveryStatus">
                Delivery Exception
                <p-sortIcon field="deliveryStatus"></p-sortIcon>
              </th>
              <th
                *ngIf="deliveryStatus === 'Delivered'"
                pSortableColumn="deliveryStatus">
                Delivery Status
                <p-sortIcon field="deliveryStatus"></p-sortIcon>
              </th>
              <th *ngIf="deliveryStatus === 'Delivery exception'">
                Description
              </th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="workflowId"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="salesOrderIdD365"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="trackingNumber"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="nickName"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th></th>
              <th>
                <div class="d-flex">
                  <p-columnFilter
                    type="text"
                    field="deliveryStatus"
                    (input)="onFilterInput($event)"
                    [showMenu]="false">
                  </p-columnFilter>
                </div>
              </th>
              <th *ngIf="deliveryStatus === 'Delivery exception'"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-statusList let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="statusList"
              [pSelectableRowIndex]="rowIndex">
              <td>{{ getPaddedWorkflowId(statusList.workflowId) }}</td>
              <td>{{ statusList.salesOrderIdD365 }}</td>
              <td>{{ statusList.trackingNumber }}</td>
              <td>{{ statusList.lineNumber }}</td>
              <td>{{ statusList.nickName }}</td>
              <td>{{ statusList.shippingMethodName }}</td>
              <td>{{ statusList.deliveryStatus }}</td>
              <td *ngIf="deliveryStatus === 'Delivery exception'">
                {{ statusList.exceptionDescription }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No record found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>
